import { useEffect, useState, type ImgHTMLAttributes, type ReactNode } from 'react';
import { getAuthenticatedObjectUrl } from '../lib/files';

type Props = Omit<ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string;
  fallback?: ReactNode;
};

export function AuthenticatedImage({ src, fallback = null, ...props }: Props) {
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    let currentUrl: string | null = null;

    getAuthenticatedObjectUrl(src)
      .then((url) => {
        currentUrl = url;
        if (active) setObjectUrl(url);
        else URL.revokeObjectURL(url);
      })
      .catch(() => {
        if (active) setObjectUrl(null);
      });

    return () => {
      active = false;
      if (currentUrl) URL.revokeObjectURL(currentUrl);
    };
  }, [src]);

  return objectUrl ? <img {...props} src={objectUrl} /> : <>{fallback}</>;
}
